import { useEffect } from "react";
import {
  Checkbox,
  DatePicker,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "../../../../components";
import { value } from "../../../../helpers";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";

const FormFiltroAvancadoAnaliseAbcClientes = ({
  filtrosAvancados,
  setFiltrosAvancados,
  setFiltrosAplicadosImpressao,
  setValidationError,
}) => {
  const { onChangeInput, onChangeDate, onChangeCheckbox } =
    useFiltrosRelatoriosHandlers(
      setFiltrosAvancados,
      setFiltrosAplicadosImpressao,
    );

  useEffect(() => {
    setFiltrosAvancados({
      ...filtrosAvancados,
      classeA: 20,
      classeB: 30,
      classeC: 50,
    });
  }, []);

  const handleChangeClasse = (e, field) => {
    const novoValor = Number(e.target.value) || 0;
    const classeA =
      field === "classeA" ? novoValor : Number(filtrosAvancados?.classeA || 0);
    const classeB =
      field === "classeB" ? novoValor : Number(filtrosAvancados?.classeB || 0);
    const classeC =
      field === "classeC" ? novoValor : Number(filtrosAvancados?.classeC || 0);
    const soma = classeA + classeB + classeC;
    if (soma > 100) return;
    onChangeInput(e, field, "number");
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            id="dataStart"
            name="Data-Start"
            label="Data Inicial"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataStart)}
            onChange={(date) => onChangeDate("dataStart", date, "Data-Start")}
            slotProps={{
              popper: { sx: { zIndex: 2000 } },
            }}
            setError={setValidationError}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            id="dataEnd"
            name="Data-End"
            label="Data Final"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataEnd)}
            onChange={(date) => onChangeDate("dataEnd", date, "Data-End")}
            slotProps={{
              popper: { sx: { zIndex: 2000 } },
            }}
            setError={setValidationError}
          />
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Select
            id="ordenarPor"
            name="ordenarPor"
            margin="normal"
            value={value.text(filtrosAvancados?.ordenarPor)}
            label="Ordenar Por"
            onChange={(event) => onChangeInput(event, "ordenarPor")}
            fullWidth
            SelectProps={{
              MenuProps: {
                disablePortal: true,
                PaperProps: {
                  sx: {
                    zIndex: 1600,
                  },
                },
              },
            }}
          >
            <MenuItem value={"NUMERICA"}>Numérica</MenuItem>
            <MenuItem value={"ALFABETICA"}>Alfabética</MenuItem>
            <MenuItem value={"VALOR_ACUMULADO"}>Valor acumulado</MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControlLabel
            sx={{ mx: 0, mt: 2 }}
            label="A"
            labelPlacement="start"
            control={
              <TextField
                id="classeA"
                name="Classe-A"
                variant="outlined"
                sx={{ ml: 1, mr: 2 }}
                type="number"
                fullWidth
                value={value.text(filtrosAvancados?.classeA)}
                onChange={(e) => handleChangeClasse(e, "classeA")}
              />
            }
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            sx={{ mx: 0, mt: 2 }}
            label="B"
            labelPlacement="start"
            control={
              <TextField
                id="classeB"
                name="Classe-B"
                variant="outlined"
                sx={{ ml: 1, mr: 2 }}
                type="number"
                fullWidth
                value={value.text(filtrosAvancados?.classeB)}
                onChange={(e) => handleChangeClasse(e, "classeB")}
              />
            }
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            sx={{ mx: 0, mt: 2 }}
            label="C"
            labelPlacement="start"
            control={
              <TextField
                id="classeC"
                name="Classe-C"
                variant="outlined"
                sx={{ ml: 1, mr: 2 }}
                type="number"
                fullWidth
                value={value.text(filtrosAvancados?.classeC)}
                onChange={(e) => handleChangeClasse(e, "classeC")}
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            label="Apenas o que é gerado para Contas a Receber"
            labelPlacement="end"
            control={
              <Checkbox
                name="apenasGeradoContasReceber"
                checked={filtrosAvancados?.apenasGeradoContasReceber}
                onChange={(event) =>
                  onChangeCheckbox(event, "Apenas-Gerado-Contas-Receber")
                }
                color="primary"
              />
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormFiltroAvancadoAnaliseAbcClientes;
